<template>
  <v-menu
    content-class="menuNotification"
    v-model="showNotification"
    offset-y
    location="bottom left"
    nudge-right="25"
    offset-x
    :close-on-click="false"
    :close-on-content-click="false"
  >
    <template #activator="{ props:menu }">
      <v-badge
        class="mr-7 ml-7 second-menu-item"
        color="primary"
        :content="notifications.length"
        bottom
        :value="notifications.length > 0"
      >
        <v-tooltip location="bottom">
          <template #activator="{ props:tooltip }">
            <v-icon
              id="menuNotifications"
              v-bind="mergeProps(menu, tooltip)"
              :icon="Icons.BELL"
            />
          </template>
          <span>{{ t('navigation.tooltip.notification') }}</span>
        </v-tooltip>
      </v-badge>
    </template>
    <v-card>
      <v-card-text class="mb-2">
        <cc-alert-info
          class="mb-4"
          v-if="notifications.length === 0"
          :text="t('navigation.notification.empty')"
        />
        <v-row class="cc-notification-list">
          <v-col
            cols="12"
            v-for="(notification, i) in notifications"
            :key="i"
            class="pb-0"
          >
            <v-alert
              color="primary"
              border="start"
              colored-border
              class="mb-0"
            >
              <template v-if="notification.hasOwnProperty('route')">
                <router-link :to="notification.route">
                  {{ notification.text }}
                </router-link>
              </template>
              <template v-else>
                <div v-dompurify-html="notification.text" />
              </template>
              <template #close>
                <v-icon
                  :aria-label="t('common.a11y.removeNotification')"
                  @click="removeNotification(notification.id)"
                  @keydown.enter="removeNotification(notification.id)"
                  @keydown.space.prevent="removeNotification(notification.id)"
                  :icon="Icons.CLOSE_CIRCLE_OUTLINE"
                />
              </template>
            </v-alert>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn @click="showNotification = false">
          {{ t('common.close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script setup lang="ts">
import {notifications, removeNotification, showNotification} from '@/composables/layout/baseLayout';
import {mergeProps} from 'vue';
import {Icons} from '@simpleforyou/client-core';
import {useI18n} from 'vue-i18n';

const {t} = useI18n();
</script>

<style scoped>

</style>
